import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    fill: PropTypes.string,
    stroke: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    fill: 'currentColor',
    stroke: 'none',
    className: null,
};

const PlayIcon = ({ fill, stroke, className }) => (
    <svg
        width="20"
        height="23"
        viewBox="0 0 20 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <path
            d="M3.25156 20.9919L17.7578 12.5935C18.7557 12.0158 18.7557 10.575 17.7578 9.99727L3.25156 1.59894C2.25156 1.01999 1 1.74158 1 2.89708L1 19.6937C1 20.8492 2.25156 21.5708 3.25156 20.9919Z"
            fill={fill}
            stroke={stroke}
        />
    </svg>
);

PlayIcon.propTypes = propTypes;
PlayIcon.defaultProps = defaultProps;

export default PlayIcon;
